<template>
    <div class="modal fade" :class="lang != 'es' && lang != 'en' && show ? 'show' : ''" :style="lang != 'es' && lang != 'en' && show ? 'display:block;background:rgba(0,0,0,0.8); !important; padding-right: 15px; display: block; z-index:1400' : ''" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content rounded-0">
              <div class="modal-header border-bottom-0 p-4 rounded-0">
                    <button type="button" class="close p-1" @click="onClose()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-0 px-4 rounded-0">
                  <h4>Estás viendo nuestro sitio web en: English</h4>
                  <p>¿Quieres cambiar a: Español?</p>
                  <div class="row mt-4">
                    <div class="col-md-6 px-2">
                      <button class="btn btn-primary rounded-0 btn-block" @click="onFresh()">Cambiar a: Español</button>
                    </div>
                    <div class="col-md-6 px-2">
                      <button class="btn btn-secondary rounded-0 btn-block" @click="onQuedate()">Quedarse en: English</button>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data(){
    return{
      lang: window.lang,
      show: true
    }
  },
  methods:{
    onClose: function(){
      this.show = false
    },
    onFresh: function(){
      localStorage.setItem('lang', 'es')
      this.$router.go()
    },
    onQuedate: function(){
      localStorage.setItem('lang', 'en')
      this.$router.go()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/partials/lang.vue